import React from 'react';
import {Avatar, Box, Button, Chip, Menu, MenuItem} from '@material-ui/core';
import {AccountCircle} from '@material-ui/icons';
import {User} from './UserContext';

type Props = {
  signOut: () => void,
  user?: User
};

const UserPill: React.FC<Props> = ({signOut, user}) => {
  const [userMenuAnchor, setUserMenuAnchor] = React.useState(null as EventTarget & Element | null);

  function handleSignoutClick(): void {
    signOut();
    setUserMenuAnchor(null);
  }

  function handleMenuOpen(e: React.MouseEvent): void {
    setUserMenuAnchor(e.currentTarget);
  }

  function handleMenuClose(): void {
    setUserMenuAnchor(null);
  }

  return (
    <Box displayPrint="none">
      {
        user
          ? <Chip
            avatar={<Avatar alt={user.name} src={user.picture} />}
            label={user.name}
            onClick={handleMenuOpen}
          />
          : <AccountCircle />
      }

      <Menu
        id="user-menu"
        anchorEl={userMenuAnchor}
        open={Boolean(userMenuAnchor)}
        onClose={handleMenuClose}
      >
        <MenuItem>
          <Button onClick={handleSignoutClick}>Sign out</Button>
        </MenuItem>
      </Menu>
    </Box>
  );
};
export default UserPill;
